/** Formatting shared by the Marketing pages and the member's "Came from" card. */

export const euro = (n: number | null | undefined) =>
    `€${Number(n ?? 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** 0.234 -> "23.4%". */
export const percent = (rate: number | null | undefined) =>
    `${(Number(rate ?? 0) * 100).toLocaleString('en-GB', { maximumFractionDigits: 1 })}%`;

/**
 * The server sends UTC times, sometimes without a zone marker; the "Z" is
 * added before parsing, as the members list and the orders page do, so the
 * admin sees their own local time rather than GMT.
 */
const parse = (value?: string | null): Date | null => {
    if (!value) return null;
    const d = new Date(/[Zz]|[+-]\d\d:\d\d$/.test(value) ? value : value + 'Z');
    return Number.isNaN(d.getTime()) ? null : d;
};

export const fmtDate = (value?: string | null) => parse(value)?.toLocaleDateString() ?? '—';

export const fmtDateTime = (value?: string | null) =>
    parse(value)?.toLocaleString(undefined, {
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
    }) ?? '—';

/** yyyy-MM of the current local month, the value an <input type="month"> holds. */
export const thisMonth = (today = new Date()) =>
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;

/** The server's error key ("error.partner_code_taken"), from an axios error or a react-admin one. */
export const errorCode = (e: any): string | null =>
    e?.response?.data?.code ?? e?.body?.code ?? null;

/** The server's translated message, when there is one. */
export const errorMessage = (e: any, fallback: string): string =>
    e?.response?.data?.error ?? e?.body?.error ?? fallback;
